// Depends

import { route, meta } from '@/helpers/routes'

import Form from './form/form'
import Index from './index/covenants'

const covenantRoutes = [
  route('edit', '/:id/edit', Form, meta('Adicionar novo convênio', true, 'guest')),
  route('create', '/create', Form, meta('Adicionar novo convênio', true, 'guest')),
  route('index', '/index', Index, meta('Lista de convênios', true, 'guest'))
]

export default covenantRoutes



// WEBPACK FOOTER //
// ./src/app/settings/covenants/routes.js